const initialState = {
    pastReviewsLoading: false,
    pastReviewsError: '',
    pastReviewsSuccess: '',
    pastReviews: {},
}

export default (state = initialState, action) => {
    switch (action.type) {
        case "PAST_REVIEWS_LOADING":
            return {
                ...state,
                pastReviewsLoading: true
            };
        case "PAST_REVIEWS_ERROR":
            return {
                ...state,
                pastReviewsLoading: false,
                pastReviewsError: action.error,
                pastReviewsSuccess: ''
            };
        case "PAST_REVIEWS_SUCCESS":
            return {
                ...state,
                pastReviewsLoading: false,
                pastReviewsError: '',
                pastReviews: action.data.past_reviews,
                pastReviewsSuccess: action.data.past_reviews || state.pastReviewsSuccess
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/pastReviews.js